<template>
	<div  v-loading="loading">
		<el-dialog  title="编辑" :visible.sync="dialogVisible" @close="close"   >
			
			<el-form label-width="80px">
				<el-form-item label="轮播图">
				    <el-upload
				      class="avatar-uploader"
				      :headers="headerObj"
				      :action="action"
				      :show-file-list="false"
				      :on-success="handleAvatarSuccess"
				      >
				      <img v-if="form.img" :src="form.img" class="avatar">
				      <i v-else class="el-icon-plus avatar-uploader-icon" style="line-height: 178px;"></i>
				    </el-upload>
				</el-form-item>
				
				
				<div style="margin-top: 30px;"></div>
				<el-form-item label="排序">
				    <el-input v-model="form.order"></el-input>
				</el-form-item>
			</el-form>
			
			<div style="height:30px"></div>
			<div style="height: 30px;text-align: center;">
				<el-button @click="tijiao" type="primary">保 存</el-button>
				 <el-button @click="close">关 闭</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
export default{
	name:'Edit',
	props:{
		id:String,
		type:String
	},
	data(){
		return {
			action:this.$path()+"/index/Upload/index",
			dialogVisible:true,
			data:[],
			loading: false,
			form:{
				img:"",
				order:"",
			},
			headerObj:{
				token:sessionStorage.getItem("token")
			}
			
		}
	},
	methods:{
		handleAvatarSuccess(res, file){
			if(res.errCode=='201'){
				this.$router.push({
					name:'/'
				})
				return;
			}
			 this.form.img = res.result;
		},
		close(){
			this.dialogVisible=false
			this.$emit("close")
		},
		async tijiao(){
			var url="/index/Carousel/Edit";
			var res=await this.$post(url,this.form)
			if(res.errCode=="1"){
				this.$success(res,this)
				this.close();
			}else{
				this.$error(res,this)
			}
		},
		handleClick(tab, event){
		},
		async GetInfo(){
			var res=await this.$get("/index/Carousel/Find",{"uuid":this.id})
			console.log(res);
		}
	},
	mounted(){
		if(this.id!="") this.GetInfo();
	}
}
</script>
<style scoped="scoped">
	div{
		text-align: left;
	}
	.text{
		width: 80%;
	}
</style>
<style>
	 .avatar-uploader .el-upload {
	    border: 1px dashed #d9d9d9;
	    border-radius: 6px;
	    cursor: pointer;
	    position: relative;
	    overflow: hidden;
	  }
	  .avatar-uploader .el-upload:hover {
	    border-color: #409EFF;
	  }
	  .avatar-uploader-icon {
	    font-size: 28px;
	    color: #8c939d;
	    width: 178px;
	    height: 178px;
	    line-height: 178px;
	    text-align: center;
	  }
	  .avatar {
	    width: 178px;
	    height: 178px;
	    display: block;
	  }
	.zZindex {
	    z-index:9999 !important;
	}
</style>
